import "./Style.css"
import React from 'react'

export const TittleH2 = ({textTittle}) => {
  return (
    <h2 className="h2">{textTittle}</h2>
  )
}
